import { createStore, combineReducers, applyMiddleware } from 'redux'
import { reducer as form } from 'redux-form'
import createSagaMiddleware from 'redux-saga'

import { reducer as aiCosts, sagas as aiCostsSagas } from './aiCostsModule'
import { reducer as app, sagas as appSagas } from './appModule'
import { reducer as common, sagas as commonSagas } from './commonModule'
import { reducer as enums, sagas as enumSagas } from './enumsModule'
import { reducer as fav, sagas as favSagas } from './favouritesModule'
import { reducer as lse, sagas as lseSagas } from './lseModule'
import { reducer as news, sagas as newsSagas } from './newsModule'
import { reducer as nexus, sagas as nexusSagas } from './nexusModule'
import { reducer as search, sagas as searchSagas } from './searchModule'
import { reducer as synopsis, sagas as synopsisSagas } from './synopsisModule'
import { reducer as user, sagas as userSagas } from './userModule'
import { reducer as advisers, sagas as advisersSagas } from './advisersModule'

const sagaMiddleware = createSagaMiddleware()

var store = createStore(
  combineReducers({
    advisers,
    aiCosts,
    app,
    common,
    enums,
    fav,
    form,
    lse,
    news,
    nexus,
    search,
    synopsis,
    user,
  }),
  applyMiddleware(sagaMiddleware)
)

sagaMiddleware.run(aiCostsSagas)
sagaMiddleware.run(appSagas)
sagaMiddleware.run(commonSagas)
sagaMiddleware.run(enumSagas)
sagaMiddleware.run(favSagas)
sagaMiddleware.run(lseSagas)
sagaMiddleware.run(newsSagas)
sagaMiddleware.run(nexusSagas)
sagaMiddleware.run(searchSagas)
sagaMiddleware.run(synopsisSagas)
sagaMiddleware.run(userSagas)
sagaMiddleware.run(advisersSagas)

export default store

